import { Tooltip } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import { ClearDiv, Label } from '../';
import { IClearProps } from '../ClearDiv';
import { TooltipContentTitle, TooltipContentWrapper } from './TooltipContent';

export interface ICol3Col9Props {
	label?: string;
	labelSize: 'sm' | 'md' | 'lg';
	labelInfo?: string;
	labelInfoTitle?: string;
	subLabelDisplayData?: any;
	className?: string;
}

const Col3Col9Left = styled.div.attrs<{}>({
	className: 'tws-col3col9-left',
})``;
Col3Col9Left.displayName = 'Col3Col9Left';

const Col3Col9Right = styled.div.attrs<{}>({
	className: 'tws-col3col9-right',
})``;
Col3Col9Right.displayName = 'Col3Col9Right';

const ChildrenContainer = styled.div`
	color: #696969;
`;
ChildrenContainer.displayName = 'ChildrenContainer';

export class Col3Col9 extends React.PureComponent<React.PropsWithChildren<ICol3Col9Props & IClearProps>, {}> {
	public static defaultProps: Partial<ICol3Col9Props> = {
		labelSize: 'md',
	};

	public render() {
		return (
			<ClearDiv
				clearHeight={this.props.clearHeight}
				clearHeightMobile={this.props.clearHeightMobile}
				clearBefore={this.props.clearBefore}
				className={'row ' + this.props.className}
			>
				<Col3Col9Left className='col-lg-3 col-sm-12'>
					{this.props.label && (
						<Label size={this.props.labelSize} className='tws-label'>
							{this.props.label}
							{this.props.labelInfo !== undefined && (
								<Tooltip id={this.props.label + '-tooltip'} contentType='html' wrapper='div'>
									<TooltipContentWrapper>
										{this.props.labelInfoTitle !== undefined && <TooltipContentTitle>{this.props.labelInfoTitle}</TooltipContentTitle>}
										{<p>{this.props.labelInfo}</p>}
									</TooltipContentWrapper>
								</Tooltip>
							)}
						</Label>
					)}
					{this.props.subLabelDisplayData !== undefined && <div>{this.props.subLabelDisplayData}</div>}
				</Col3Col9Left>
				<Col3Col9Right className='col-lg-9 col-sm-12'>
					<ChildrenContainer>{this.props.children}</ChildrenContainer>
				</Col3Col9Right>
			</ClearDiv>
		);
	}
}
